'use client';

import { SvgChevronright } from '@common/icon';

import { TERM_CATEGORY } from '@/api';
import { useGlobalStore } from '@/stores/GlobalStore';

const BUSINESS_INFO_HREF =
  'https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7058602126';

const POLICY_LINKS = [
  {
    label: '이용약관',
    onClickType: TERM_CATEGORY.SERVICE_TERMS,
  },
  {
    label: '사용자정보확인',
    href: BUSINESS_INFO_HREF,
  },
  {
    label: '개인정보처리방침',
    onClickType: TERM_CATEGORY.PRIVACY_POLICY,
    className: 'text-B-500',
  },
  {
    label: '마케팅이용동의',
    onClickType: TERM_CATEGORY.MARKETING_TERMS,
  },
  {
    label: '위치기반서비스 이용약관',
    onClickType: TERM_CATEGORY.LOCATION_POLICY_SELECT,
  },
] as const;

export const SidePolicyLinks = () => {
  const [setTermsDrawerType, setIsHomeFooterModalOpen] = useGlobalStore(
    (state) => [state.setTermsDrawerType, state.setIsHomeFooterModalOpen],
  );

  return (
    <section className="mt-32">
      <ul className="flex flex-col gap-4">
        {POLICY_LINKS.map((link) => (
          <li key={link.label}>
            {'href' in link ? (
              <a
                href={link.href}
                target="_blank"
                rel="noreferrer external"
                className="font-400 text-Gray-600 typo-caption1"
              >
                {link.label}
              </a>
            ) : (
              <button
                type="button"
                className="font-400 text-Gray-600 typo-caption1"
                onClick={() => setTermsDrawerType(link.onClickType)}
              >
                {link.label}
              </button>
            )}
          </li>
        ))}
      </ul>

      <div className="mt-12 flex flex-col gap-32 border-t border-Gray-300 py-8">
        <div className="flex items-center gap-20">
          <p className="font-400 text-Gray-600 typo-caption1">ⓒ Wello Inc.</p>
          <div className="flex flex-1 justify-end">
            <button
              type="button"
              onClick={() => setIsHomeFooterModalOpen(true)}
              className="flex h-26 items-center justify-center gap-4 rounded-xxsmall py-8"
            >
              <span className="font-600 text-Gray-600 typo-caption2">
                더보기
              </span>
              <SvgChevronright className="size-10 text-Gray-600" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};
